import * as _ from 'lodash';
import * as React from 'react';

import { styled } from '../../theme';
import { Btn, ButtonAction, ButtonIconPosition, ButtonType, ButtonWidget } from '../buttons/ButtonWidget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface ConfigurableCardWidgetProps {
  title: string;
  configured: boolean;
  onConfigure: ButtonAction;
  secondaryActions?: Btn[];
  className?: string;
  content?: React.ReactNode;
  description?: string;
  meta?: JSX.Element | null;
}

namespace S {
  export const Container = styled.div``;

  const BORDER_RADIUS = '10px';

  export const CardContainer = styled.div`
    position: relative;
    border-radius: ${BORDER_RADIUS};

    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: 5px;
    margin-right: 5px;
    background: rgba(0, 0, 0, 0.4);
  `;

  export const CardContentContainer = styled.div`
    padding: 16px;
    min-height: 190px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end;
    flex-grow: 1;
  `;

  export const Title = styled.div`
    margin-top: 10px;
    color: ${(p) => p.theme.text.primary};
    width: 100%;
    text-align: center;
  `;

  export const Description = styled.div`
    color: ${(p) => p.theme.text.secondary};
    font-size: 12px;
    width: 100%;
    text-align: center;
  `;

  export const MetaContainer = styled.div`
    margin-bottom: 5px;
  `;

  export const ConfigureContainer = styled.div<{ configured?: boolean }>`
    width: 100%;
    border-bottom-right-radius: ${BORDER_RADIUS};
    border-bottom-left-radius: ${BORDER_RADIUS};
    background: ${(p) => (p.configured ? p.theme.beta.background : 'black')};
  `;

  export const ButtonContainer = styled.div`
    margin-top: 5px;
  `;

  export const ConfigureButton = styled(ButtonWidget)<{ configured?: boolean }>`
    height: 40px;
    color: ${(p) => (p.configured ? p.theme.text.primary : undefined)};
    opacity: ${(p) => (p.configured ? '1' : undefined)};
  `;

  export const SecondaryActionButton = styled(ButtonWidget)`
    font-size: 12px;
    color: ${(p) => p.theme.text.secondary};
  `;
}

export const ConfigurableCardWidget: React.FC<ConfigurableCardWidgetProps> = (props) => {
  const { className, configured, content, description, meta, onConfigure, secondaryActions, title } = props;

  return (
    <S.Container className={className}>
      <S.CardContainer>
        <S.CardContentContainer>
          <S.MetaContainer>
            <S.MetaContainer>{meta}</S.MetaContainer>
            {/* TODO */}
            {/* {contextActions?.length ? <KebabMenuWidget items={contextActions} /> : null} */}
          </S.MetaContainer>
          <S.Container>{content}</S.Container>
          <S.Title>{title}</S.Title>
          {description && <S.Description>{description}</S.Description>}
        </S.CardContentContainer>
        <S.ConfigureContainer configured={configured}>
          {configured ? (
            <S.ConfigureButton
              configured={true}
              type={ButtonType.TERTIARY}
              label="Configured"
              icon={<FontAwesomeIcon icon="check" />}
              iconPosition={ButtonIconPosition.RIGHT}
              disabled={true}
              action={() => {}}
            />
          ) : (
            <S.ConfigureButton
              type={ButtonType.TERTIARY}
              action={onConfigure}
              label="Configure"
              icon={<FontAwesomeIcon icon="gear" />}
              iconPosition={ButtonIconPosition.RIGHT}
            />
          )}
        </S.ConfigureContainer>
      </S.CardContainer>
      <S.ButtonContainer>
        {_.map(secondaryActions, (action, index) => (
          <S.SecondaryActionButton key={index} type={ButtonType.TERTIARY} {...action} />
        ))}
      </S.ButtonContainer>
    </S.Container>
  );
};
